import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import "../Gallery.css";

//http://www.mpsckp.com/gallery/school/images/1.webp
const School = () => {
  const numbers = [1, 2, 3, 4, 5,6,7,8,9];
  // const i;
  const listItems = numbers.map((number, index) => {
    if (index % 3 === 0)
      return (
        <Row>
          <Col md={4}>
            <div className="mbox">
              <Item
                original={`${"http://www.mpsckp.com/gallery/school/images/"}${number}${".webp"}`}
                thumbnail={`${"http://www.mpsckp.com/gallery/school/images/"}${number}${".webp"}`}
                width="1024"
                height="768"
                className="img-fluid"
              >
                {({ ref, open }) => (
                  <img
                    ref={ref}
                    onClick={open}
                    src={`${"http://www.mpsckp.com/gallery/school/images/"}${number}${".webp"}`}
                    className="img-fluid"
                    alt=""
                  />
                )}
              </Item>
            </div>
          </Col>
          <Col md={4}>
            <div className="mbox">
              <Item
                original={`${"http://www.mpsckp.com/gallery/school/images/"}${
                  number + 1
                }${".webp"}`}
                thumbnail={`${"http://www.mpsckp.com/gallery/school/images/"}${
                  number + 1
                }${".webp"}`}
                width="1024"
                height="768"
                className="img-fluid"
              >
                {({ ref, open }) => (
                  <img
                    ref={ref}
                    onClick={open}
                    src={`${"http://www.mpsckp.com/gallery/school/images/"}${
                      number + 1
                    }${".webp"}`}
                    className="img-fluid"
                    alt=""
                  />
                )}
              </Item>
            </div>
          </Col>
          <Col md={4}>
            <div className="mbox">
              <Item
                original={`${"http://www.mpsckp.com/gallery/school/images/"}${number+2}${".webp"}`}
                thumbnail={`${"http://www.mpsckp.com/gallery/school/images/"}${number+2}${".webp"}`}
                width="1024"
                height="768"
                className="img-fluid"
              >
                {({ ref, open }) => (
                  <img
                    ref={ref}
                    onClick={open}
                    src={`${"http://www.mpsckp.com/gallery/school/images/"}${number+2}${".webp"}`}
                    className="img-fluid"
                    alt=""
                  />
                )}
              </Item>
            </div>
          </Col>
        </Row>
      );
    else {
      return "";
    }
  });

  return (
    <div className="inner-body">
      <Container fluid>
        <Row className="inner">
          <div className="inner-head-outer">
            <div className="inner-head">
              <Col>
                <h2>The School</h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="../">
                    <i className="fa fa-home"></i> Home
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to={"/mgallery"}>
                      <i className="fa fa-camera"></i> Gallery
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>The School</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </div>
          </div>
        </Row>
      </Container>
      <div className="mib relative">
        <div className="leftline"></div>

        <div className="bottomline"></div>
        <Container>
          <Gallery>{listItems}</Gallery>
        </Container>
      </div>
    </div>
  );
};

export default School;
